import ApplicationStore from "../stores/ApplicationStore";
import { getAttributionMetadata } from "./attribution";

/**
 * Metadata attached to every order. The acquisition source comes from the first-/last-touch
 * attribution captured at the start of each visit (see utils/attribution.ts) -- not
 * document.referrer at checkout time, which would be the storefront's own previous page.
 */
export const getOrderMetadata = (): { [key: string]: string } => {
    return {
        userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "",
        pageUrl: typeof window !== "undefined" ? window.location.href : "",
        ...getAttributionMetadata(),
        ...ApplicationStore.metadata,
    };
};
